import CreateManager from './CreateManager';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../services/AppContext';
import { ModalContext } from '../../modal/ModalContext';
import { copyToClipboard } from '../../services/Clipboard';
import MultiButtons from '../../components/global/MultiButtons';
import { React, Fragment, useState, useContext, useEffect } from 'react';
import { DeleteConfirmationModal } from '../../modal/global/DeleteConfirmationModal';

const Managers = () => {
    const { t } = useTranslation();
    const { showModal } = useContext(ModalContext);
    const { apiClient, user, notify } = useContext(AppContext);
    const [managersData, setManagersData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState();

    const fetchData = async (month) => {
        if (user.role !== 'Admin') {
            return;
        }

        let now = new Date();

        if (month) {
            now = new Date(month);
        }

        month = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, 0, 0, 0)).toISOString();

        const until = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0)).toISOString();

        const data = await apiClient.getManagers({
            from: month,
            to: until
        });

        if (!data.hasErrors) {
            setManagersData(data);
        }
    };

    useEffect(() => {
        fetchData(selectedMonth);
    }, [selectedMonth]);

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    const handleAddManager = async () => {
        const created = await showModal(<CreateManager />);

        if (created) fetchData();
    };

    const handleResetPassword = async (id) => {
        const response = await apiClient.requestPasswordChange({
            userId: id
        });

        if (response.token) {
            const resetLink = window.env.REACT_APP_WEB_URL + '/reset-password?token=' + response.token;
            copyToClipboard(resetLink);
        }
    };

    const handleDelete = async (manager) => {
        const shouldDelete = await showModal(<DeleteConfirmationModal subject={manager.name} />);

        if (shouldDelete) {
            await apiClient.deleteUser(manager.id);
            fetchData();
            notify(t('pages.managers.notifications.managerDeleted'), 'success');
        }
    };

    return (
        <div>
            <div className="filter-container mg-b-1">
                <select
                    id="month"
                    value={selectedMonth}
                    onChange={handleMonthChange}>
                    {[...Array(6).keys()].map(offset => {
                        const date = new Date();
                        date.setDate(1);
                        date.setMonth(new Date().getMonth() - offset);
                        if (date < new Date(2024, 11, 1)) return null;
                        const value = date.toISOString().split('T')[0].slice(0, 7);
                        const monthName = date.toLocaleString('default', { month: 'long' }).toLocaleLowerCase();
                        const letters = monthName.replace(/[^a-zA-Z]/g, '');
                        const translated = !/^[a-zA-Z]+$/.test(letters);

                        return (
                            <option key={value} value={value}>
                                {translated ? date.toLocaleString('default', { month: 'long' }) : t(`common.months.${date.toLocaleString('default', { month: 'long' }).toLocaleLowerCase()}`)} {date.toLocaleString('default', { year: 'numeric' })}
                            </option>
                        );
                    })}
                </select>

                <div className='mg-l-1'>
                    <MultiButtons>
                        <button onClick={handleAddManager}>
                            {t('pages.managers.actions.add')}
                        </button>
                    </MultiButtons>
                </div>
            </div>

            <div className="grid-container-3">
                <div className="grid-header">
                    <div className="container">
                        <p>{t('pages.managers.headers.name')}</p>
                    </div>
                </div>
                <div className="grid-header">
                    <div className="container">
                        <p>{t('pages.managers.headers.earned')}</p>
                    </div>
                </div>
                <div className="grid-header">
                    <div className="container">
                    </div>
                </div>
                {managersData.map((manager, index) => (
                    <Fragment key={index}>
                        <div className="grid-item">
                            <div className="container">
                                <p>{manager.name}</p>
                            </div>
                        </div>
                        <div className="grid-item">
                            <div className="container">
                                <p>{manager.moneyEarned.amount} {manager.moneyEarned.currency.symbol}</p>
                            </div>
                        </div>

                        <MultiButtons>
                            <button
                                className='background-warning width-100p'
                                onClick={() => handleResetPassword(manager.id)}
                            >
                                {t('pages.managers.actions.reset')}
                            </button>
                            <button
                                className='background-danger width-100p'
                                onClick={() => handleDelete(manager)}
                            >
                                {t('pages.managers.actions.delete')}
                            </button>
                        </MultiButtons>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default Managers;